<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='1000px'>
    <el-form :model='form' label-width='140px' label-position='right' :rules='rules'
             ref='ruleForm' class='settlement-form mt20'>
      <el-row :gutter='10'>
        <el-col :span='12'>
          <el-form-item  label='委托商：' prop="consignorName">
            <el-select v-model="form.consignorName" size="mini" filterable style="width: 100%" placeholder="请选择委托商" value-key="id" >
              <el-option v-for="item in consignorOptions" :key="item.id" :label="item.customer_name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='业务编号：' prop='businessNo'>
            <el-input @blur='getTransportSectionList' v-model='form.businessNo' size='mini'
                      placeholder='请输入业务编号' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='时间：' prop='years'>
            <el-date-picker v-model='form.years' size='mini'
                            value-format='yyyyMM' type='month' placeholder='请选择时间' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='业务单位：' prop='businessUnitId'>
            <el-select v-model='form.businessUnitId' filterable size='mini' placeholder='请选择业务单位'>
              <el-option v-for='item in selectedData.attrList1' :key='item.id'
                         :label='item.classaName' :value='item.id' />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='业务类型：' prop='businessTypeId'>
            <el-select v-model='form.businessTypeId' filterable size='mini' placeholder='请选择业务类型'>
              <el-option v-for='item in selectedData.attrList2' :key='item.id'
                         :label='item.classaName'
                         :value='item.id' />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='业务板块：' prop='businesSegmentId'>
            <el-select v-model='form.businesSegmentId' filterable size='mini' placeholder='请选择业务板块'>
              <el-option v-for='item in selectedData.attrList3' :key='item.id'
                         :label='item.classaName'
                         :value='item.id' />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='联运类型：' prop='transportTypeId'>
            <el-select v-model='form.transportTypeId' filterable size='mini' placeholder='请选择联运类型'>
              <el-option v-for='item in selectedData.attrList4' :key='item.id'
                         :label='item.classaName'
                         :value='item.id' />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='货类：' prop='goodsId'>
            <el-select v-model='form.goodsId' filterable size='mini' placeholder='请选择货类'>
              <el-option v-for='item in selectedData.attrList5' :key='item.id'
                         :label='item.classaName'
                         :value='item.id' />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='业务来源：' prop='businessSourceId'>
            <el-select v-model='form.businessSourceId' filterable size='mini' placeholder='请选择业务来源'>
              <el-option v-for='item in selectedData.attrList6' :key='item.id'
                         :label='item.classaName'
                         :value='item.id' />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='客户行业：' prop='customerIndustryId'>
            <el-select v-model='form.customerIndustryId' filterable size='mini'
                       placeholder='请选择客户行业'>
              <el-option v-for='item in selectedData.attrList7' :key='item.id'
                         :label='item.classaName'
                         :value='item.id' />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='是否固定业务：' prop='fixedBusinessId'>
            <el-select v-model='form.fixedBusinessId' filterable size='mini'
                       placeholder='请选择是否固定业务'>
              <el-option v-for='item in selectedData.attrList8' :key='item.id'
                         :label='item.classaName'
                         :value='item.id' />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='计量单位：' prop='meteringCompany'>
            <el-input v-model='form.meteringCompany' size='mini' placeholder='请输入计量单位' />
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='下包属性：' prop='packageAttributeId'>
            <el-select v-model='form.packageAttributeId' filterable size='mini'
                       placeholder='请选择下包属性'>
              <el-option v-for='item in selectedData.attrList9' :key='item.id'
                         :label='item.classaName'
                         :value='item.id' />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='24'>
          <el-form-item label='备注：'>
            <el-input type='textarea' v-model='form.remarks' size='mini' placeholder='请输入备注' />
          </el-form-item>
        </el-col>
      </el-row>

      <div-border label='运段信息'>
        <div class='yang' v-for='(item, index) in form.transportSectionList' :key='index'
             v-loading='transportSectionListLoading'>
          <el-row :gutter='10'>
            <el-col :span='24'>
              <i v-show='form.transportSectionList.length > 1' class='el-icon-error pointer right'
                 @click='removeTransportSection(index)' />
            </el-col>
            <el-col :span='12'>
              <el-form-item label='业务量：' :rules='rules.businessVolume'
                            :prop='`transportSectionList[${index}].businessVolume`'>
                <el-input v-model='item.businessVolume' size='mini' placeholder='请输入业务量' />
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='重量：' :rules='rules.weight'
                            :prop='`transportSectionList[${index}].weight`'>
                <el-input v-model='item.weight' size='mini' placeholder='请输入重量' />
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='不含税收入：' :rules='rules.taxExcluded'
                            :prop='`transportSectionList[${index}].taxExcluded`'>
                <el-input v-model='item.taxExcluded' size='mini' placeholder='请输入不含税收入'
                          type='number' />
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='物流工具：'>
                <el-input v-model='item.logisticsTools' size='mini' placeholder='请输入物流工具' />
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='物流方式：'>
                <el-radio-group v-model='item.logisticsMode'>
                  <el-radio :label='0'>公路</el-radio>
                  <el-radio :label='1'>江运</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='物流属性：'>
                <el-radio-group v-model='item.logisticsAttribute'>
                  <el-radio :label='0'>民生</el-radio>
                  <el-radio :label='1'>非民生</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div v-if="dialogTitle === '新增' || dialogTitle === '编辑'" class='teamAdd'>
          <span>添加运段：</span>
          <div class='add' @click='addTransportSection'>+</div>
        </div>
      </div-border>

      <div class='flex-center-center mt10 mb20'>
        <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'> 确认
        </el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import {
    monthInformationCollection,
    monthlySummaryMonthAdd,
    monthlySummaryMonthDetails,
    monthlySummaryMonthUpdate,
    monthlySummaryMonthQuery,
  } from '@/service/financial';
  import divBorder from '@/components/divBorder.vue';
  import { customerInfoSelectList } from '@/service/getData';

  export default {
    name: 'monthForm',
    components: { divBorder },
    data() {
      return {
        dialogTitle: '新增',
        dialogVisible: false,
        defaultForm: {},
        form: {
          consignorName: '',
          consignorId: '',
          businessNo: '',
          years: '',
          businessUnitId: '',
          businessUnit: '',
          businessTypeId: '',
          businessType: '',
          businesSegmentId: '',
          businesSegment: '',
          transportTypeId: '',
          transportType: '',
          goodsId: '',
          goods: '',
          businessSourceId: '',
          businessSource: '',
          customerIndustryId: '',
          customerIndustry: '',
          fixedBusinessId: '',
          fixedBusiness: '',
          meteringCompany: '',
          packageAttributeId: '',
          packageAttribute: '',
          remarks: '',
          transportSectionList: [
            {
              logisticsTools: '',
              businessVolume: '',
              weight: '',
              taxExcluded: '',
              logisticsMode: '',
              logisticsAttribute: ''
            },
          ],
        },
        consignorOptions: [],
        transportSectionList: {
          logisticsTools: '',
          businessVolume: '',
          weight: '',
          taxExcluded: '',
          logisticsMode: '',
          logisticsAttribute: ''
        },
        transportSectionListLoading: false,
        rules: {
            consignorName: [
            {
              required: true,
              message: '请选择委托商',
              trigger: 'blur',
            },
          ],
          businessNo: [
            {
              required: true,
              message: '请输入业务编号',
              trigger: 'blur',
            },
          ],
          years: [
            {
              required: true,
              message: '请选择时间',
              trigger: 'blur',
            },
          ],
          businessUnitId: [
            {
              required: true,
              message: '请选择业务单位',
              trigger: 'blur',
            },
          ],
          businessTypeId: [
            {
              required: true,
              message: '请选择业务类型',
              trigger: 'blur',
            },
          ],
          businesSegmentId: [
            {
              required: true,
              message: '请选择业务板块',
              trigger: 'blur',
            },
          ],
          transportTypeId: [
            {
              required: true,
              message: '请选择联运类型',
              trigger: 'blur',
            },
          ],
          goodsId: [
            {
              required: true,
              message: '请选择货类',
              trigger: 'blur',
            },
          ],
          businessSourceId: [
            {
              required: true,
              message: '请选择业务来源',
              trigger: 'blur',
            },
          ],
          customerIndustryId: [
            {
              required: true,
              message: '请选择客户行业',
              trigger: 'blur',
            },
          ],
          fixedBusinessId: [
            {
              required: true,
              message: '请选择是否固定业务',
              trigger: 'blur',
            },
          ],
          meteringCompany: [
            {
              required: true,
              message: '请输入计量单位',
              trigger: 'blur',
            },
          ],
          packageAttributeId: [
            {
              required: true,
              message: '请选择下包属性',
              trigger: 'blur',
            },
          ],
          businessVolume: [
            {
              required: true,
              message: '请输入业务量',
              trigger: 'blur',
            },
          ],
          weight: [
            {
              required: true,
              message: '请输入重量',
              trigger: 'blur',
            },
          ],
          taxExcluded: [
            {
              required: true,
              message: '请输不含税收入',
              trigger: 'blur',
            },
          ],
        },
        submitLoading: false,
        selectedData: {},
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      async getDetails(id) {
        this.form.id = id;
        this.formLoading = true;
        const {
          status,
          message,
          data,
        } = await monthlySummaryMonthDetails(id);
        this.formLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.form = JSON.parse(JSON.stringify(data));
        // 处理无用数据
        this.form.transportSectionList = [];
        data.transportSectionList.forEach(item => {
          this.form.transportSectionList.push({
            transportSection: item.transportSection,
            businessVolume: item.businessVolume,
            weight: item.weight,
            taxExcluded: item.taxExcluded,
            logisticsMode: item.logisticsMode,
            logisticsAttribute: item.logisticsAttribute,
          });
        });
      },
      dialogOpen(title, id) {
        this.dialogTitle = title;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.getSelectedData();
        this.getConsignorInfoSelectList()
        if (id) this.getDetails(id);
        this.dialogVisible = true;
      },
      async getSelectedData() {
        const {
          status,
          message,
          data,
        } = await monthlySummaryMonthQuery();
        if (status !== 0) return this.message.warning(message);
        this.selectedData = data;
      },
      // 获取委托商
      async getConsignorInfoSelectList() {
        const { status, message, data } = await customerInfoSelectList();
        if (status !== 0) return this.$message.warning(message);
        this.consignorOptions = data;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.submitLoading = true;
            let res = {};
            const updateField = (list, fieldId, fieldName) => {
              const option = list.find(item => item.id === this.form[fieldId]);
              this.form[fieldName] = option ? option.classaName : null;
              this.form[fieldId] = option ? option.id : null;
            };
            updateField(this.selectedData.attrList1, 'businessUnitId', 'businessUnit');
            updateField(this.selectedData.attrList2, 'businessTypeId', 'businessType');
            updateField(this.selectedData.attrList3, 'businesSegmentId', 'businesSegment');
            updateField(this.selectedData.attrList4, 'transportTypeId', 'transportType');
            updateField(this.selectedData.attrList5, 'goodsId', 'goods');
            updateField(this.selectedData.attrList6, 'businessSourceId', 'businessSource');
            updateField(this.selectedData.attrList7, 'customerIndustryId', 'customerIndustry');
            updateField(this.selectedData.attrList8, 'fixedBusinessId', 'fixedBusiness');
            updateField(this.selectedData.attrList9, 'packageAttributeId', 'packageAttribute');
            if (this.dialogTitle === '新增') {
              const selectValue = this.consignorOptions.find(item => item.id === this.form.consignorName)
              this.form.consignorName = selectValue.customer_name;
              this.form.consignorId = selectValue.id;
              res = await monthlySummaryMonthAdd(this.form);
            } else {
              if(this.form.consignorId !== this.form.consignorId) {
                const selectValue = this.consignorOptions.find(item => item.id === this.form.consignorName);
                this.form.consignorName = selectValue.customer_name;
                this.form.consignorId = selectValue.id;
              }
              res = await monthlySummaryMonthUpdate(this.form);
            }
            this.submitLoading = false;
            if (res.status !== 0) return this.$message.warning(res.message);
            this.$message.success(res.message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
      // 删除
      removeTransportSection(index) {
        this.$confirm('确定要删除当前运段吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (this.form.transportSectionList.length && this.form.transportSectionList.length > 1) this.form.transportSectionList.splice(index, 1);
          })
          .catch();
      },
      addTransportSection() {
        let flag = false;
        if (this.form.transportSectionList && this.form.transportSectionList.length > 0) {
          this.form.transportSectionList.forEach(res => {
            for (const resKey in res) {
              if (!res[resKey] || res[resKey] === '') flag = true;
            }
          });
        }
        if (flag) {
          return this.$message.warning('请填写完当前运段信息后新增运段！');
        }
        this.form.transportSectionList.push(JSON.parse(JSON.stringify(this.transportSectionList)));
      },
      async getTransportSectionList() {
        if (this.form.businessNo === '') return;
        this.transportSectionListLoading = true;
        const {
          status,
          message,
          data,
        } = await monthInformationCollection(this.form);
        this.transportSectionListLoading = false;
        if (status !== 0) {
          this.form.transportSectionList = [];
          return this.$message.warning(message);
        }
        this.form.transportSectionList = data;
      },
    },
  };
</script>

<style lang='scss' scoped>
  .settlement-form {
    width: 80%;
    margin: 0 auto;
  }

  .el-date-editor.el-input, .el-select--mini {
    width: 100%;
  }

  .team {

    &Add {
      display: flex;
      align-items: center;
      margin: 20px 0;

      .add {
        width: 20px !important;
        height: 20px;
        padding-bottom: 3px;
        background-color: #999;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        margin-right: 15px;

        &:hover {
          cursor: pointer;
        }
      }

      span {
        font-size: 14px;
        color: #606266;
        font-weight: 700;
      }
    }

    &Item {
      display: flex;
      align-items: center;
      color: #999;
      font-size: 14px;
      margin-top: 10px;
      padding-bottom: 10px;

      span {
        margin-left: 5px;
        color: #606266;
        font-weight: 700;
      }

      border-bottom: 1px solid #CBCBCB;
    }
  }

  .yang {
    margin-top: 10px;
    border-bottom: 1px solid #cbcbcb;

    .el-form-item {

      margin-bottom: 15px;

      .el-form-item__label {
        //width: 150px !important;
        /*color: #060606;*/
      }

      .el-input {
        width: 100%;
      }

      .el-textarea {
        width: 100%;

      }
    }

  }
</style>
